const horseInitialState = {
    horseRaceList: [],
    horseMarkets: [],
};

export default horseInitialState;
